import React from 'react';
import { useSummaryHeatSources } from '../hooks/useSummaryHeatSources';

export const SUMMARY_HEAT_SOURCES_LABEL = 'Dołącz informacje o źródłach ciepła';

/**
 * Pole opcji „ze źródłami ciepła" — JEDNO dla każdego pobrania podsumowania kontroli (PDF budynku,
 * karty lokali, ZIP podsumowań, paczka wg filtrów, komplet). Stan wspólny: useSummaryHeatSources.
 * Domyślnie odznaczone = kopia dla zarządcy bez źródeł ciepła (Bronek 14.10).
 */
export function SummaryHeatSourcesOption({ disabled = false, style }: { disabled?: boolean; style?: React.CSSProperties }) {
  const [checked, setChecked] = useSummaryHeatSources();
  return (
    <label
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 'var(--space-2)',
        fontFamily: 'var(--font-sans)', fontSize: 'var(--text-caption)', color: 'var(--text-secondary)',
        cursor: 'pointer', ...style,
      }}
      title={'Podsumowanie dla zarządcy jest domyślnie BEZ źródeł ciepła (wspólnych budynku i lokali). '
        + 'Zaznacz, żeby je dołączyć — dotyczy każdego pobrania podsumowania, także w komplecie i w kartach lokali. '
        + 'Załącznik wysyłany do CEEB zawsze je zawiera.'}
    >
      <input
        type="checkbox"
        data-testid="summary-heat-sources-option"
        checked={checked}
        disabled={disabled}
        onChange={(e) => setChecked(e.target.checked)}
      />
      {SUMMARY_HEAT_SOURCES_LABEL}
    </label>
  );
}
